import Perso from "../../assets/icons/Perso.svg";
import location from "../../assets/icons/location-border.svg";
import appointment from "../../assets/icons/date.svg";
import cursor from "../../assets/icons/cursor-icon.svg";
import doc from "../../assets/icons/doc-icon.svg";
import click from "../../assets/icons/tab-click-icon.svg";
import { Col, Divider, Row } from "antd";
import useIsMobile from "../../biblio/mobileVersion/useIsMobile";
import dayjs from "dayjs";
import teaching from "../../assets/icons/teaching-icon.svg";
import date from "../../assets/icons/date-time-icon.svg";
import money from "../../assets/icons/money-icon.svg";
import road from "../../assets/icons/road.svg";
import { getCardItem } from "../utils/utils";

interface CardProps {
  program: any;
}

const CardDetailsProgram = ({ program }: CardProps) => {
  const isMobile = useIsMobile();
  return (
    <div className="takaful--card-details-project-container">
      <div
        className="takaful--card-details-project-image"
        style={{
          backgroundImage: `url(${program?.detail_image_ids})`,
        }}
      >
        <div className="takaful--card-details-project-name">
          <span>{program?.category_id}</span>
        </div>
      </div>

      <Row gutter={16} justify={"space-between"} dir="rtl">
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          xxl={23}
          xl={23}
          lg={23}
          md={23}
          sm={23}
          xs={23}
          className="takaful--card-details-project-titles"
          style={{ marginTop: "3vh" }}
        >
          <span className="takaful--card-details-project-title">
            {program?.program_name}
          </span>

          <span className="takaful--card-details-project-text">
            {program?.details}
          </span>

          <Row gutter={8} className="takaful--card-details-program-info">
            <Col
              className="takaful--card-details-project-info-1"
              xxl={6}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <img src={Perso} alt="person" />
              <span>{program?.not_beneficiary_targeted_number} شخص</span>
            </Col>
            <Col
              className="takaful--card-details-project-info-1"
              xxl={6}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <img src={location} alt="place" />
              <span>{program?.activity_place}</span>
            </Col>

            <Col
              xxl={12}
              xl={12}
              lg={12}
              md={12}
              sm={19}
              xs={20}
              style={{ marginTop: "0.5rem" }}
            >
              <Row
                align={"middle"}
                className="takaful--program-details-card-date"
              >
                <Col xxl={4} xl={5} lg={4} md={4} sm={5} xs={5}>
                  <img src={appointment} alt="" />
                </Col>
                <Col
                  xxl={5}
                  xl={7}
                  lg={5}
                  md={7}
                  sm={10}
                  xs={10}
                  className="takaful--program-card-date-container"
                >
                  <span className="takaful--program-card-date">
                    <p>البداية:</p>
                    {program?.start_date
                      ? dayjs(program?.start_date, "YYYY-MM-DD").format(
                          "YYYY/MM/DD"
                        )
                      : ""}
                  </span>
                </Col>
                <Col
                  xxl={1}
                  xl={2}
                  lg={1}
                  md={1}
                  sm={1}
                  xs={1}
                  className="takaful--program-card-divider-container"
                >
                  <Divider
                    type="vertical"
                    className="takaful--program-card-divider"
                  />
                </Col>
                <Col xxl={6} xl={7} lg={6} md={6} sm={8} xs={8}>
                  <span className="takaful--program-card-date">
                    <p>النهاية:</p>
                    {program?.end_date
                      ? dayjs(program?.end_date, "YYYY-MM-DD").format(
                          "YYYY/MM/DD"
                        )
                      : ""}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row
        gutter={16}
        align={"middle"}
        className="takaful--service-details-card-bordred-container"
      >
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
          {getCardItem(
            "الأيام المتبقية للترشح",
            program?.inscription_remaining_duration,
            "يوم",
            date
          )}
        </Col>
        <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
          {getCardItem(
            "قيمة الإشتراك",
            program?.registration_fees,
            "ريال",
            money
          )}
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
          {getCardItem("عدد الحصص", program?.total_lessons, "حصة", teaching)}
        </Col>
        <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
          {getCardItem(
            "عدد المواقع",
            program?.remaining_not_beneficiary_application_count === 0
              ? program?.remaining_not_beneficiary_provision_application_count
              : program?.remaining_not_beneficiary_application_count,
            "موقع",
            road
          )}
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
      </Row>

      {/** Statistics */}
      <Row
        gutter={16}
        justify={isMobile ? "center" : "space-between"}
        style={{ paddingTop: "2rem" }}
      >
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div
            className="takaful--card-details-project-statistics takaful--card-details-project-statistics-first 
              takaful--card-details-project-border-right"
          >
            <div className="takaful--card-details-project-statistics-title takaful--card-details-program-statistics-title">
              <span>آخر ترشح</span>
              <img width={30} height={30} src={cursor} alt="card-details" />
            </div>
            <span>{program?.last_application_period}</span>
          </div>
        </Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div className="takaful--card-details-project-statistics takaful--card-details-project-border-center">
            <div className="takaful--card-details-project-statistics-title takaful--card-details-program-statistics-title">
              <span>عدد الزيارات</span>
              <img width={30} height={30} src={click} alt="card-details" />
            </div>
            <span>{program?.visit_count}</span>
          </div>
        </Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div className="takaful--card-details-project-statistics takaful--card-details-project-border-left">
            <div className="takaful--card-details-project-statistics-title takaful--card-details-program-statistics-title">
              <span>عدد الترشحات</span>
              <img width={30} height={30} src={doc} alt="card-details" />
            </div>
            <span>{program?.application_count}</span>
          </div>
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
      </Row>
    </div>
  );
};

export default CardDetailsProgram;
